<div mat-dialog-title class="dialogContainer dialog-info">
    <label class="labelTitle">{{ 'SI_QUOTE' | translate }}</label>
    <button type="button" class="btn-close btn-close-white shadow-none p-0" aria-label="Close dialog"
        (click)="onCancelContinue()"></button>
</div>

<mat-dialog-content class="dialogContent">
    <div>{{ 'DO_YOU_WANT_TO_PUBLISH_BEFORE_CLOSING' | translate }}</div>
</mat-dialog-content>

<mat-dialog-actions class="dialogActionsBtns">
    <button mat-raised-button color="primary" (click)="onPublishClose()">{{ 'PUBLISH_AND_CLOSE' | translate }}</button>
    <button mat-raised-button color="primary" (click)="onDiscardClose()">{{ 'DISCARD_AND_CLOSE' | translate }}</button>
    <button mat-raised-button color="warn" (click)="onCancelContinue()">{{ 'CANCEL_AND_CONTINUE_EDITING' | translate }}</button>
</mat-dialog-actions>
